import React from "react";
import Address from "../components/account/address";
import Navbar from "../components/common/navbar";
import Footer from "../components/common/footer";
import MobileSidebarLink from "../components/account/mobileSidebarLink";

const AddressPage = () => {
  return (
    <div>
      <Navbar />
      <div className="md:mx-16 flex">
      <div className="hidden md:block">
      <MobileSidebarLink />
        </div>
        <Address />
      </div>
      <Footer/>
    </div>
  );
};

export default AddressPage;
